import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Button } from "react-bootstrap"

const propTypes = {
    // from app/static/frontend/search-new/containers/BulkActions/sidebar/BulkActionsSidebar
    activeSidebarButton: PropTypes.number,
    bulkActionValidOptions: PropTypes.array.isRequired,
    // from shared/search/searchify/bulkactions/action-creators
    updateSidebarButton: PropTypes.func.isRequired,
    // defaultProps
    // from app/static/frontend/search-new/components/BulkActions/BulkActionsConsole
    reset: PropTypes.func.isRequired,
    uniqueFlvId: PropTypes.string.isRequired,
}

// generic component
export const BulkActionsSidebar = (props) => (
    <div className="bulk-actions-console-sidebar">
        {props.bulkActionValidOptions.map((bulkActionType) => (
            <Button
                className={classNames("btn-info bulk-actions-console-sidebar-button", {
                    active: props.activeSidebarButton === bulkActionType.value,
                })}
                data-cy={`bulk-actions-console-sidebar-button-${bulkActionType.key}`}
                key={bulkActionType.label}
                onClick={() => {
                    props.updateSidebarButton(props.uniqueFlvId, bulkActionType.key, bulkActionType.value, props.reset)
                }}
            >
                <i className={classNames("fa fa-fw", bulkActionType.icon)} />
                {bulkActionType.label}
                <i className="fa fa-fw fa-chevron-right" />
            </Button>
        ))}
    </div>
)
BulkActionsSidebar.propTypes = propTypes
BulkActionsSidebar.defaultProps = {}

export default BulkActionsSidebar
